import React, { useEffect, useState } from "react";
import Faq from "react-faq-component";
import Img1 from '../images/aboutus.png'
import Img2 from '../images/ringer.png'
import Img3 from '../images/ring76.png'
import Img4 from '../images/Grou77.png'
import { Row, Col } from 'antd'
import AOS from 'aos';
const data = {
  title: "Frequently Asked Questions",
  rows: [
    {
      title: "What types of jewelry does Magdiam offer?",
      content: `Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.`,
    },
    {
      title: "Are all diamonds at Magdiam ethically sourced?",
      content:
        "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.",
    },
    {
      title: "Can I customize a piece of jewelry?",
      content: `Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor. `,
    },
    {
      title: "What is the difference between natural and lab-grown diamonds?",
      content: `Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor. `,
    },
  ],
};

const styles = {
  titleTextColor: "#000",
  rowTitleColor: "#000",
  rowTitlefamliy: 'CustomFont',
  rowContentColor: "grey",
  // arrowColor: "red",
};

const config = {
  // animate: true,
  // arrowIcon: "V",
  // tabFocus: true
};
function Aboutus() {
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState(null)
  const [faqContent, setFaqContent] = useState(null)
  const fetchContent = async () => {
    setLoading(true)
    const response = await fetch('/api/cms/about/fetch', {
      method: 'POST'
    })
    const result = await response.json()
    setContent(result.content)
    setLoading(false)
  }
  const fetchFaq = async () => {
    setLoading(true)
    const response = await fetch('/api/cms/faq/fetch', {
      method: 'POST'
    })
    const result = await response.json()

    setFaqContent({
      title: result.content.title, rows: result.content.item.map((item) => ({
        title: item.question,
        content: item.answer
      }))
    })
    setLoading(false)
  }
  useEffect(() => {
    fetchContent()
    fetchFaq()
  }, [])
  return (
    <div>
      <section className="aboutus">
        <div className="container">
          <Row
            gutter={[16, 16]}
            justify="middle"
          >
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="Brilliance">
                <h2>{content?.section1?.title}</h2>
                <p>{content?.section1?.description}</p>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="brilliance-img">
                <img src={content?.section1?.image} alt="img" style={{ width: '100%', height: 'auto' }} />
              </div>
            </Col>
          </Row>
          <Row
            gutter={[50, 16]}
            justify="middle"
          >
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="brilliance-img">
                <img src={content?.section2?.image} alt="img" style={{ width: '100%', height: 'auto' }} />
              </div>

            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="Brilliance">
                <h2>{content?.section2?.title}</h2>
                <p>{content?.section2?.description}</p>
              </div>
            </Col>
          </Row>
          <Row
            gutter={[50, 16]}
            justify="middle"
          >
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="Brilliance">
                <h2>{content?.section3?.title}</h2>
                <p>{content?.section3?.description}</p>
              </div>

            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="brilliance-img">
                <img src={content?.section3?.image} alt="img" style={{ width: '100%', height: 'auto' }} />
              </div>

            </Col>
          </Row>
          <Row
            gutter={[50, 16]}
            justify="middle"
          >
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="brilliance-img">
                <img src={Img4} alt="img" style={{ width: '100%', height: 'auto' }} />
              </div>

            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="Brilliance">
                <Faq className="faq"
                  data={faqContent}
                  styles={styles}
                  config={config}
                />
              </div>


            </Col>
          </Row>
        </div>
      </section>
    </div>
  )
}
<style>

</style>

export default Aboutus
